import { render } from "./OpeningBalanceModal.vue?vue&type=template&id=328b76b8&scoped=true"
import script from "./OpeningBalanceModal.vue?vue&type=script&lang=js"
export * from "./OpeningBalanceModal.vue?vue&type=script&lang=js"

import "./OpeningBalanceModal.vue?vue&type=style&index=0&id=328b76b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328b76b8"]])

export default __exports__